/**
 * Action de la partie operations
 */
export const GET_OPERATIONS = 'GET_OPERATIONS';
export const GET_OPERATIONS_SUCCESS = 'GET_OPERATIONS_SUCCESS';
export const GET_OPERATIONS_FAILURE = 'GET_OPERATIONS_FAILURE';

export const getOperations = params => ({
  type: GET_OPERATIONS,
  payload: params
});

export const GET_OPERATION = 'GET_OPERATION';
export const GET_OPERATION_SUCCESS = 'GET_OPERATION_SUCCESS';
export const GET_OPERATION_FAILURE = 'GET_OPERATION_FAILURE';

export const getOperation = operationId => ({
  type: GET_OPERATION,
  payload: operationId
});
